import { LogoMark } from "./Logo";

const ITEMS = ["Artwork 360", "Medlyn 360", "Mumbai → USA", "Human-led", "Virtual Medical Assistants", "360° Ownership", "HIPAA Compliant", "Print-ready", "Partners, not vendors"];

export const Marquee = ({ dark = true }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee" className={`relative overflow-hidden border-y ${dark ? "border-white/10 bg-brand-slate text-white" : "border-brand-indigo/10 bg-white text-brand-indigo"} py-6`}>
      <div className="flex w-max animate-marquee items-center gap-12 will-change-transform hover:[animation-play-state:paused]">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-display text-2xl font-semibold tracking-tight sm:text-3xl">{t}</span>
            <LogoMark size={22} className={dark ? "text-white/40" : "text-brand-indigo/40"} />
          </div>
        ))}
      </div>
    </div>
  );
};
